import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getCookie = (key) => {
  try {
    return cookies.get(key);
  } catch (e) {
    console.warn('Cookie access blocked:', e);
    return null;
  }
};

export const getLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn('LocalStorage access blocked:', e);
    return null;
  }
};

export const setLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.warn('LocalStorage write blocked:', e);
  }
};

export const removeLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn('LocalStorage remove blocked:', e);
  }
};